import { server } from '@/services/'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

const state = {
  isFetching: {
    loginStats: false,
    geoStats: false
  },
  loginStats: {
    daily: [],
    monthly: [],
    yearly: []
  },
  geoStats: []
}

const getters = {}

const mutations = {
  setLoginStats(state, payload) {
    state.loginStats[payload.type] = payload.data
  },
  setIsFetching(state, payload) {
    state.isFetching[payload.widget] = payload.value
  },
  setGeoStats(state, payload) {
    state.geoStats = payload
  }
}

const actions = {
  getDailyLoginStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      server.get('/rptDailyUsersLogin/1').then(
        resp => {
          commit('setLoginStats', {type: payload, data: resp.data.msgContent.data})
          resolve()
        },
        err => reject()
      )
    })
  },
  getMonthlyLoginStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      server.get('/rptDailyUsersLogin/2').then(
        resp => {
          commit('setLoginStats', {type: payload, data: resp.data.msgContent.data})
          resolve()
        },
        err => reject()
      )
    })
  },
  getYearlyLoginStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      server.get('/rptDailyUsersLogin/3').then(
        resp => {
          commit('setLoginStats', {type: payload, data: resp.data.msgContent.data})
          resolve()
        },
        err => reject()
      )
    })
  },
  getGeoStats({ commit }) {
    return new Promise((resolve, reject) => {
      server.get('/rptAllUser_LastAccess_GPS_Info').then(
        resp => {
          commit('setGeoStats', resp.data.msgContent.data)
          resolve()
        },
        err => reject()
      )
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
